module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-kia.73111421.png";